import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, FormGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { MultiSelect } from 'react-multi-select-component';
import { useTranslation } from 'react-i18next';
import Loader from '../../Components/Utility/Loader/Loader';
import * as action from './store/User.action';
import { getCompanyUsers } from '../RangePlan/ProductList/store/ProductList.action';
import { CloseIcon } from '../../bombiix-icon';

function AddEditUserGroup({ onOpen, id, title, itemList, toggle }) {
  const { t } = useTranslation('common');

  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(false);
  const [name, setName] = useState(null);
  const [usersList, setUsersList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCatOne, setSelectedCataOne] = useState([]);
  const [selectedCatTwo, setSelectedCatTwo] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState([]);

  const document = {
    name,
    users: selectedUsers,
    brand: selectedBrand,
    catOne: selectedCatOne,
    catTwo: selectedCatTwo,
    supplier: selectedSupplier,
  };

  const firstExuit = useCallback(async () => {
    setShowLoader(true);
    const usersList = await dispatch(getCompanyUsers());
    if (usersList) {
      setUsersList(usersList?.data);
      setShowLoader(false);
    }
  }, [dispatch]);

  useEffect(() => {
    firstExuit();
  }, [firstExuit]);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const addUsersToGroup = (selected) => {
    setSelectedUsers(selected);
    setValue('users', selected, {
      shouldValidate: true,
    });
  };

  const SelectedBrand = (selected) => {
    setSelectedBrand(selected);
    setValue('brand', selected, {
      shouldValidate: true,
    });
  };

  const SelectedCataOne = (selected) => {
    setSelectedCataOne(selected);
    setValue('catOne', selected, {
      shouldValidate: true,
    });
  };

  const SelectedCatTwo = (selected) => {
    setSelectedCatTwo(selected);
    setValue('catTwo', selected, {
      shouldValidate: true,
    });
  };

  const SelectedSupplier = (selected) => {
    setSelectedSupplier(selected);
    setValue('supplier', selected, {
      shouldValidate: true,
    });
  };

  const onSubmitMethod = async () => {
    if (id) {
      document.groupId = id;
      await dispatch(action.updateUserGroupsCards(document, t));
      await dispatch(action.fetchUserGroupsCards());
      toggle();
    } else {
      await dispatch(action.addUserGroupsCards(document, t));
      await dispatch(action.fetchUserGroupsCards());
      toggle();
    }
  };

  const forDataIndex = () => {
    return itemList && itemList.length > 0 ? itemList.findIndex((item) => item?._id === id) : 0;
  };

  useEffect(() => {
    if (id) {
      const dataIndex = forDataIndex();
      const value = itemList[dataIndex];
      if (value) {
        setName(value.name);
        setValue('name', value.name, {
          shouldValidate: true,
        });
        addUsersToGroup(value.users.map((val) => val._id));
        SelectedBrand(value.brand.map((val) => val._id));
        SelectedCataOne(value.catOne.map((val) => val._id));
        SelectedCatTwo(value.catTwo.map((val) => val._id));
        SelectedSupplier(value.supplier.map((val) => val._id));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, itemList]);

  return (
    <Modal show={onOpen} size="md" backdrop="static" aria-labelledby="contained-modal-title-vcenter" className="custom-modal modal-small" onHide={toggle}>
      <form>
        <Modal.Header>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
            <CloseIcon size={28} onClick={toggle} className="cursor-pointer" />
          </div>
        </Modal.Header>
        <Modal.Body>
          {showLoader && <Loader />}
          {!showLoader && (
            <>
              <FormGroup>
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    name="name"
                    placeholder={t('USER_GROUP_VIEW.ENTER_GROUP_NAME')}
                    {...register('name', {
                      required: !name,
                      validate: (value) => !!value.trim() || t('USER_GROUP_VIEW.NO_WHITE_SPACE'),
                    })}
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                    className="form-control"
                  />
                  <label className="asterisk-req">
                    {t('USER_GROUP_VIEW.NAME')}
                    <span>*</span>
                  </label>
                </div>
                {errors.name && <small className="error-message">{t('USER_GROUP_VIEW.VALIDATION_ERROR.NAME_IS_REQUIRED')}</small>}
              </FormGroup>
              <FormGroup>
                <label className="select-label asterisk-req">
                  {t('USER_GROUP_VIEW.USERS')}
                  <span>*</span>
                </label>

                <MultiSelect
                  name="users"
                  {...register('users', { required: true })}
                  options={usersList.map((e) => {
                    e.label = `${e.firstName} ${e.lastName}`;
                    e.value = e?._id;

                    return e;
                  })}
                  className="custom-multiselect"
                  value={usersList.filter((element) => {
                    return selectedUsers.includes(element?._id);
                  })}
                  onChange={(selected) => addUsersToGroup(selected.map((val) => val._id))}
                  labelledBy={t('USER_GROUP_VIEW.SELECT_USERS')}
                />
                {errors.users && selectedUsers.length === 0 && <span className="error-message">{t('USER_GROUP_VIEW.VALIDATION_ERROR.USERS_IS_REQUIRED')}</span>}
              </FormGroup>

              <div className="modal-buttons mt-4 d-flex justify-content-between">
                <button onClick={toggle} type="button" className="btn btn-default">
                  {t('COMMON_LABEL.CANCEL')}
                </button>

                <button onClick={handleSubmit(onSubmitMethod)} type="button" className="btn btn-default">
                  {id ? t('COMMON_LABEL.UPDATE') : t('COMMON_LABEL.ADD')}
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </form>
    </Modal>
  );
}

export default AddEditUserGroup;
